import { useFormikContext } from "formik"
import React, { useRef } from "react"
import { useRouteLoaderData } from "react-router-dom"
import { findField, updateField } from "@app/utils/form"

export const useJobObserver = (currentFieldsets) => {
	const { values, setValues } = useFormikContext()
	const { office, jobs } = useRouteLoaderData("root")
	const jobLocationID = values.kundenundeinsatzort_einsatzort_adressetyp
	const customerId = values.kundenundeinsatzort_kunde_kunde__ID
	const customer = office?.kundenliste.find(
		({ KUNDENNR }) => {
			return KUNDENNR.toString() === customerId?.toString()
		},
	)
	let jobLocation = customer?.EinsatzAdressen?.find(({ Adresse }) => Adresse === jobLocationID)
	if (!jobLocation) {
		// find default location
		jobLocation = customer?.EinsatzAdressen?.find(({ ist_Kundenadresse }) => ist_Kundenadresse === true)
	}

	const field_ueberlassungals = findField(currentFieldsets, "taetigkeit_beschreibung_ueberlassungals")

	let res = React.useMemo(() => {
		if (customerId && field_ueberlassungals) {
			const berufeKeys = jobLocation?.Berufe?.map(b => b.Berufschluessel) ?? []

			let customerJobs = []
			let otherJobs = []

			jobs.forEach(job => {
				if (berufeKeys.includes(job.Berufschluessel)) {
					const jobRef = jobLocation.Berufe.find(b => b.Berufschluessel === job.Berufschluessel)
					customerJobs.push({
						id: job.Berufschluessel,
						label: `${job.Beruf}`,
						value: job.Berufschluessel,
						tasks: jobRef?.TAETIGKEIT?.split(";").map(entry => entry.trim()),
					})
				} else {
					otherJobs.push({
						id: job.Berufschluessel,
						label: `${job.Beruf}`,
						value: job.Berufschluessel,
					})
				}
			})

			const availableJobs = [...customerJobs, ...otherJobs]

			const newFieldsets = updateField(currentFieldsets, "taetigkeit_beschreibung_ueberlassungals", (element) => {
				return {
					...element,
					jobs: availableJobs,
				}
			})

			// setCurrentFieldsets(newFieldsets);
			return {
				fieldsets: newFieldsets
			}
		}

		return {
			fieldsets: currentFieldsets
		}
	}, [jobLocation, customerId, field_ueberlassungals?.name, currentFieldsets])

	const value_job = values["taetigkeit_beschreibung_ueberlassungals"]
	const prevJobValue = useRef(value_job)
	res = React.useMemo(() => {
		const field_ueberlassungals = findField(res.fieldsets, "taetigkeit_beschreibung_ueberlassungals")
		if (field_ueberlassungals) {
			if (prevJobValue.current !== value_job) {
				const tasks = field_ueberlassungals.jobs?.find(({ label }) => label === value_job)?.tasks
				const newDescription = tasks ? tasks.join("\n") + "\n" : "";

				// setting the value directly doesn't seem to be the proper way, but fixes the issue that the new value isn't propagted to the field
				values.taetigkeit_beschreibung_taetigkeitsbeschreibung = newDescription
				setValues({
					...values,
					"taetigkeit_beschreibung_taetigkeitsbeschreibung": newDescription
				})
				prevJobValue.current = value_job
			}
		}
		return {
			fieldsets: res.fieldsets
		}
	}, [value_job, prevJobValue.current, res.fieldsets])

	return res
}

const JobObserver = ({ currentFieldsets, setCurrentFieldsets }) => {
	const { fieldsets } = useJobObserver(currentFieldsets)
	setCurrentFieldsets(fieldsets)
	return null
}

export default JobObserver
